<template lang="pug">
  v-card
    v-toolbar.elevation-0(height="45" color="gray")
      v-toolbar-title
        h1.subheading Current Month Revenue
    v-card-text(v-if="isLoading")
      v-progress-linear( size="70" color="pink" width="7" indeterminate)
    v-list.list-350(v-if="!isLoading")
      template(v-for="(row, index) in RevenueByProduct" )
        v-list-tile(:key="row.id" avatar ripple )
          v-list-tile-avatar {{row.qty}}
          v-list-tile-content.mr-3
            v-list-tile-title {{ row.name }}
          v-list-tile-action.text-truncate
              animated-number.subheading(:value="row.revenue" :formatValue="formatToPrice" :duration="1000")
        v-divider(v-if="index + 1 < RevenueByProduct.length" :key="index") 
</template>

<script>
import AnimatedNumber from "animated-number-vue";
import dashbaordService from '../service.js'
export default {
  data() {
    return {
      RevenueByProduct: [],
      isLoading: true
    }
  },
  components: {
    AnimatedNumber
  },
  methods: {
    formatToPrice(value) {
      return `$ ${value.toFixed(0)}`;
    },
    getRevenueByProduct() {
      dashbaordService.getCurrentMonthRevenueByProduct()
      .then(result => {
        console.log('result is :', result)
        this.RevenueByProduct = result.data
        this.isLoading = false
      })
    },
  },
  mounted() {
    this.getRevenueByProduct()
  }
}
</script>

<style scoped>
</style>